export default {
	home: {
		afunOriginals: "AFun Original",
		slots: "Slot",
		liveCasino: "Kasino Langsung",
		casualGames: "Permainan Kasual",
		newReleases: "Rilis Baru",
		casinoTitle: "Kasino",
		casinoDesc: "Nikmati permainan kasino dengan ribuan slot, dealer langsung, dan permainan meja",
		goToCasino: "Ke Kasino",
		sportsTitle: "Olahraga",
		sportsDesc: "Bertaruh pada Sepak Bola, Basket, Tenis, dan olahraga lainnya dengan odds terbaik",
		goToSports: "Ke Olahraga",
		liveTitle: "Langsung",
		liveDesc: "Aksi real-time dengan dealer langsung dan pengalaman bermain interaktif",
		goToLive: "Ke Langsung",
		latestBetRace: "Taruhan & Balapan Terbaru",
		sports: "Olahraga",
		latestBets: "Taruhan Terbaru",
		game: "Permainan",
		player: "Pemain",
		bet: "Taruhan",
		multiplier: "Pengganda",
		profit: "Keuntungan",
		top10Games: "10 Permainan Teratas",
		vip: "VIP",
		rewards: "Hadiah",
		affiliate: "Afiliasi",
		promotion: "Promosi"
	},

	latestBetRace: {
		title: "Grand Prix Papan Peringkat Game",
		playerBetRank: "Taruhan Pemain Hari Ini",
		playerWinRank: "Kemenangan Pemain Hari Ini",
		gameBetRank: "Taruhan Game Hari Ini",
		gameWinRank: "Pengembalian Game Hari Ini",
		player: "Pemain",
		game: "Game",
		bet: "Taruhan",
		profit: "Menang",
		ratio: "Rasio Pembayaran",
		totalBet: "Total Taruhan",
		totalReturn: "Total Pengembalian",
		maxBet: "Taruhan Maks",
		gameRatio: "% Pengembalian",
		noData: "Tidak Ada Data",
	},

	GameClassify: {
		casinoTitle: "Kasino",
		casinoDesc: "Nikmati permainan kasino dari penyedia teratas",
		casinoBtn: "Ke Kasino",
		sportsTitle: "Olahraga",
		sportsDesc: "Taruhan Sepak Bola, Kriket, NFL, eSports & lebih dari 80 cabang olahraga",
		sportsBtn: "Ke Olahraga",
		liveTitle: "Langsung",
		liveDesc: "Aksi langsung waktu nyata dengan dealer live",
		liveBtn: "Ke Live"
	}
}